module.exports = __webpack_public_path__ + "img/ynbf2.91480e45.png";